import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Tab,
  Tabs,
  Toast,
} from "react-bootstrap";
import { Clock, Trash, XCircleFill } from "react-bootstrap-icons";
import { Link, useNavigate } from "react-router-dom";
import API from "../../components/API/API";
import FAQsFieldset from "../../components/FAQsFieldset/FAQsFieldset";
import FeedbackFieldset from "../../components/FeedbackFieldset/FeedbackFieldset";
import SingleFieldset from "../../components/SingleFieldset/SingleFieldset";
import SpeakerFieldset from "../../components/SpeakerFieldset/SponsorFieldset";
import SponsorFieldset from "../../components/SponsorFieldset/SponsorFieldset";
import VideoTriggerUploadFieldSet from "../../components/VideoUploader/videoTriggerUploadFieldSet";
import BannerUploaderEdit from "../../components/bannerUploaderEdit/bannerUploaderEdit";
import ConvertMinutesToTime from "../../components/convertFromMinutes/convertFromMinutes  ";
import FileTriggerUploadFieldSet from "../../components/fileUploadFieldSet/fileTriggerUploadFieldSet";
import CustomLoader from "../../components/loader/loader";
import ScheduleDateModalCourse from "../../components/scheduleDateModal/scheduleDateModalCourse";
import SubDomainRouter from "../../components/subDomainRouter/subDomainRouter";
import TokenDetails from "../../components/useUserDetails/useTokenDetails";
import * as Actions from "../../constants/baseUrl";
import withRouter from "../../constants/withRouter";
import UploadFile from "../../helper/UploadFile";

function AddEditPropertyEvent(props) {
  const item_id = props.params.id;

  const navigate = useNavigate();
  const entityType = "cohort";
  const entities = "cohorts";
  const cohortAlias = SubDomainRouter("cohortAlias");

  const myToken = localStorage.getItem("token");
  const tokenDetails = TokenDetails();
  const myUserId = tokenDetails?.Email;

  const attachmentFields = [
    {
      content: "",
      extension: "",
      field_name: "",
      url: "",
    },
  ];
  const sponsorFields = [
    {
      sponsor_category: "",
      sponsor_grade: "",
      sponsor_logo_title: "",
      sponsor_logo_url: "",
      sponsor_website_url: "",
    },
  ];
  const speakersFields = [
    {
      first_name: "",
      last_name: "",
      Phone: "",
      email: "dev@test.",
      whatsapp: "",
      post: "",
      profile_link: "",
      star_rating: "",
      bio: "",
    },
  ];

  const [reqLoading, setReqLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [step, setStep] = useState(1);
  const [entityTypesData, setEntityTypesData] = useState([]);
  const [modes, setModes] = useState([]);
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({
    userId: myUserId,
    type: entityType,
    entity_type: entityType,
    listing_image_url: "",
    listing_image_content: "",
    listing_image_extension: "",
    hero_image_url: "",
    hero_image_content: "",
    hero_image_extension: "",
  });
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [selectedTimeZone, setSelectedTimeZone] = useState(null);

  const [documentData, setDocumentData] = useState(attachmentFields);
  const [imageData, setImageData] = useState(attachmentFields);
  const [videoData, setVideoData] = useState(attachmentFields);

  const [FAQs, setFAQs] = useState([{ question: "", answer: "" }]);
  const [sponsors, setSponsors] = useState(sponsorFields);
  const [speakers, setSpeakers] = useState(speakersFields);
  const [sessionTopics, setSessionTopics] = useState([{ topic: "" }]);
  const [videoFeedbacks, setVideoFeedbacks] = useState([{}]);
  const [textFeedbacks, setTextFeedbacks] = useState([{}]);
  // Schedule modal
  const [scheduleModalShow, setScheduleModalShow] = useState(false);
  // check values
  const [hasValue, setHasValue] = useState(false);
  const [isValid, setIsValid] = useState(false);

  const populateList = async (id) => {
    try {
      if (!id) {
        setLoading(false);
        return;
      }

      const response = await fetch(
        `${Actions.BASE_URL}items/${entityType}/${id}`,
        {
          headers: {
            Authorization: "Bearer " + myToken,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const resData = await response.json();

      setFAQs(resData?.data?.FAQs || [{ question: "", answer: "" }]);
      setSponsors(resData?.data?.sponsors || sponsorFields);
      setSpeakers(resData?.data?.speakers || speakersFields);
      setSessionTopics(resData?.data?.sessionTopics || [{ topic: "" }]);
      setVideoFeedbacks(resData?.data?.videoFeedbacks || [{}]);
      setTextFeedbacks(resData?.data?.textFeedbacks || [{}]);

      setImageData(resData?.data?.attachments?.images || attachmentFields);
      setDocumentData(
        resData?.data?.attachments?.documents || attachmentFields
      );
      setVideoData(resData?.data?.attachments?.videos || attachmentFields);

      setFormData({
        ...resData?.data,
      });
      setLoading(false);
    } catch (error) {
      console.error("There was an error", error);
    }
  };

  const handleFieldChange = (fieldName, fieldValue) => {
    setFormData((prevState) => ({
      ...prevState,
      [fieldName]: fieldValue,
    }));
  };

  const step1Fields = [
    "title",
    "description",
    "category",
    "subcategorylevel1",
    "subcategorylevel2",
    "start_date",
    "start_time",
    "duration",
  ];

  const areFieldsFilled = (fieldNames, state) => {
    return fieldNames.every((fieldName) => state[fieldName]);
  };

  const isStep1FieldsFilled = areFieldsFilled(step1Fields, formData);

  const handleNext = () => {
    const isSubcategoryPaid =
      formData?.subcategorylevel1 && formData?.subcategorylevel1 === "paid";
    const isStep1FieldsFilled = step1Fields?.every(
      (field) => field && formData[field]
    );

    if (
      isStep1FieldsFilled &&
      (!isSubcategoryPaid ||
        (isSubcategoryPaid && formData?.currency && formData?.amount))
    ) {
      setStep((prevStep) => prevStep + 1);
      setHasValue(false);
      setIsValid(true);
    } else {
      setHasValue(true);
      setIsValid(true);
      window.scrollTo(0, 0);
    }
  };

  const handlePrevious = () => {
    setStep((prevStep) => prevStep - 1);
  };

  useEffect(() => {
    populateList(item_id);
    fetchFilterTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item_id]);

  // Category type fetched from ENUM
  const fetchFilterTypes = async () => {
    try {
      const data = await API("get", "configs");
      const categorySettings = data?.categorysettings || {};
      const propertyEventsObj = categorySettings.courseNames || {};
      const teachingModeObj = categorySettings.teachingModes || {};
      const paymentTypesObj = categorySettings.paymentTypes || {};

      const mapToObject = (sourceObj) =>
        Object.entries(sourceObj).reduce((acc, [key, value]) => {
          acc[key] = {
            key: key,
            value: value,
          };
          return acc;
        }, {});

      setCategories(mapToObject(propertyEventsObj));
      setEntityTypesData(mapToObject(teachingModeObj));
      setModes(mapToObject(paymentTypesObj));
    } catch (error) {
      console.error("Error fetching filter types:", error);
      // Handle error, e.g., show an error message to the user
    }
  };

  const addField = (setField, field) => {
    setField([...field, {}]);
  };
  const removeItemById = (fields, setFields, itemId) => {
    const updatedItems = fields.filter((item) => item.id !== itemId);
    setFields(updatedItems);
  };

  // Timezone user
  useEffect(() => {
    // Set the default timezone to the user's current timezone
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setSelectedTimeZone({ label: userTimezone, value: userTimezone });
  }, []);

  let localTime = "";
  if (formData?.start_time && selectedTimeZone.value) {
    const [utcHours, utcMinutes] = formData?.start_time
      ?.split(":")
      ?.map(Number);

    const localDate = new Date();
    localDate?.setUTCHours(utcHours, utcMinutes);

    const localHours = localDate?.getHours();
    const localMinutes = localDate?.getMinutes();

    const period = localHours >= 12 ? "PM" : "AM";
    localTime = `${localHours % 12 || 12}:${localMinutes
      ?.toString()
      .padStart(2, "0")} ${period}`;
  }

  // *--------------------------------

  const handleSubmit = (event) => {
    event.preventDefault();
    setReqLoading(true);
    const addedAttachments = {
      documents: documentData,
      images: imageData,
      videos: videoData,
    };
    const data = {
      ...formData,
      FAQs: FAQs,
      sponsors: sponsors,
      speakers: speakers,
      sessionTopics: sessionTopics,
      videoFeedbacks: videoFeedbacks,
      textFeedbacks: textFeedbacks,
      attachments: addedAttachments,
      amount: formData?.amount,
    };

    const reqData = {
      userId: myUserId,
      type: entityType,
      host: window.location.host,
      header: {
        host: window.location.host,
        userId: myUserId,
      },
      data: {
        userId: myUserId,
        ...data,
      },
    };

    if (item_id) {
      axios
        .put(`${Actions.BASE_URL}items/${entityType}/${item_id}`, reqData, {
          headers: {
            Authorization: "Bearer " + myToken,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          navigate(`/${entityType}/items/`);
        })
        .catch((error) => {
          console.error("API request failed:", error);
        })
        .finally(() => {
          setReqLoading(false);
        });
    } else {
      axios
        .post(`${Actions.BASE_URL}items`, reqData, {
          headers: {
            Authorization: "Bearer " + myToken,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          navigate(`/share/items_${entityType}/${res.data.id}/`);
        })
        .catch((error) => {
          console.error("API request failed:", error);
        })
        .finally(() => {
          setReqLoading(false);
        });
    }
  };

  return (
    <Container fluid="lg" className="demosEditSection">
      {reqLoading ? (
        <>
          <span className="register-loader"> </span>
          <span className="spinnerOverlay"></span>
        </>
      ) : null}

      {loading ? (
        <CustomLoader />
      ) : (
        <Row>
          <Form action="" role="form" onSubmit={handleSubmit}>
            <h1 className="text-center text-capitalize">
              {item_id ? "Edit" : "Add"}&nbsp;
              {cohortAlias ? cohortAlias : "propertyEvent"}
            </h1>
            <div className="demosEditHeader text-center mb-3 mb-lg-5">
              <p>Add details below</p>
              <ul className="demosEditList">
                <li>
                  <button
                    type="button"
                    className={
                      step === 1 ? "active stepstriggers" : "stepstriggers"
                    }
                    onClick={() => setStep(1)}
                  >
                    <span>1</span>
                  </button>
                </li>
                <li>
                  <button
                    type="button"
                    className={
                      step === 2 ? "active stepstriggers" : "stepstriggers"
                    }
                    onClick={() => setStep(2)}
                    disabled={!isStep1FieldsFilled}
                  >
                    <span>2</span>
                  </button>
                </li>
                <li>
                  <button
                    disabled={!isStep1FieldsFilled}
                    type="button"
                    className={
                      step === 3 ? "active stepstriggers" : "stepstriggers"
                    }
                    onClick={() => setStep(3)}
                  >
                    <span>3</span>
                  </button>
                </li>
                <li>
                  <button
                    disabled={!isStep1FieldsFilled}
                    type="button"
                    className={
                      step === 4 ? "active stepstriggers" : "stepstriggers"
                    }
                    onClick={() => setStep(4)}
                  >
                    <span>4</span>
                  </button>
                </li>
                <li>
                  <button
                    disabled={!isStep1FieldsFilled}
                    type="button"
                    className={
                      step === 5 ? "active stepstriggers" : "stepstriggers"
                    }
                    onClick={() => setStep(5)}
                  >
                    <span>5</span>
                  </button>
                </li>
                <li>
                  <button
                    disabled={!isStep1FieldsFilled}
                    type="button"
                    className={
                      step === 6 ? "active stepstriggers" : "stepstriggers"
                    }
                    onClick={() => setStep(6)}
                  >
                    <span>6</span>
                  </button>
                </li>
                <li>
                  <button
                    disabled={!isStep1FieldsFilled}
                    type="button"
                    className={
                      step === 7 ? "active stepstriggers" : "stepstriggers"
                    }
                    onClick={() => setStep(7)}
                  >
                    <span>7</span>
                  </button>
                </li>
                <li>
                  <button
                    disabled={!isStep1FieldsFilled}
                    type="button"
                    className={
                      step === 8 ? "active stepstriggers" : "stepstriggers"
                    }
                    onClick={() => setStep(8)}
                  >
                    <span>8</span>
                  </button>
                </li>
              </ul>
            </div>

            {step === 1 && (
              <fieldset className="wizard-fieldset show demosAddForm">
                {!item_id && (
                  <Link
                    to={"/startups/add"}
                    className="btn add-button mb-3 ms-auto d-flex w-fit text-decoration-none"
                  >
                    Apply to Cohort
                  </Link>
                )}
                <Row className="mx-0">
                  <Col md={12}>
                    <small className="text-end d-block text-dark">
                      required<span className="text-danger">*</span>
                    </small>
                    <Form.Group className="form-floating mb-3">
                      <Form.Control
                        autoFocus
                        type="text"
                        className={`italicInput ${isValid && hasValue && !formData.title
                          ? "border-danger"
                          : ""
                          }`}
                        id="title"
                        required
                        value={formData?.title}
                        placeholder="Enter Event Title"
                        name="title"
                        onChange={(e) =>
                          handleFieldChange("title", e.target.value)
                        }
                      />
                      <Form.Label className="formLabel" htmlFor="title">
                        Title
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className="form-floating mb-3">
                      <Form.Control
                        type="text"
                        id="subtitle"
                        required
                        value={formData?.subtitle}
                        placeholder="Enter Event Title"
                        name="subtitle"
                        onChange={(e) =>
                          handleFieldChange("subtitle", e.target.value)
                        }
                      />
                      <Form.Label className="formLabel" htmlFor="subtitle">
                        Subtitle
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  {/* Data Append from schedule popup */}
                  <Col md={6}>
                    <small className="text-end d-block text-dark">
                      required<span className="text-danger">*</span>
                    </small>
                    <Form.Group className="form-floating mb-3 position-relative">
                      <Form.Control
                        type="button"
                        value={formData?.start_date || "YYYY/MM/DD"}
                        className={`${isValid && hasValue && !formData.start_date
                          ? "border-danger"
                          : ""
                          }`}
                        required
                        name="start_date"
                        id="start_date"
                        onClick={() => setScheduleModalShow(true)}
                      />
                      <Form.Label className="form-label" htmlFor="start_date">
                        Start Date
                      </Form.Label>
                      <Toast
                        show={showToast}
                        onClose={() => setShowToast(false)}
                        autohide
                        delay={3000}
                        style={{
                          position: "absolute",
                          top: "100%",
                          right: 0,
                          zIndex: "99",
                        }}
                      >
                        <Toast.Header closeButton={false}>
                          <strong className="mr-auto text-danger">
                            <Clock />
                            &nbsp;Error
                          </strong>
                        </Toast.Header>
                        <Toast.Body>
                          Invalid date. Please select a date not earlier than
                          today.
                        </Toast.Body>
                      </Toast>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <small className="text-end d-block text-dark">
                      required<span className="text-danger">*</span>
                    </small>
                    <Form.Group className="form-floating mb-3">
                      <Form.Control
                        type="button"
                        id="duration"
                        className={`${isValid && hasValue && !formData.duration
                          ? "border-danger"
                          : ""
                          }`}
                        required
                        value={
                          formData?.duration
                            ? ConvertMinutesToTime({
                              minutes: formData?.duration,
                            })
                            : "Select Your Event Duration"
                        }
                        name="duration"
                        onClick={() => setScheduleModalShow(true)}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <small className="text-end d-block text-dark">
                      required<span className="text-danger">*</span>
                    </small>
                    <Form.Group className="form-floating mb-3">
                      <Form.Control
                        type="button"
                        required
                        className={`${isValid && hasValue && !formData.start_time
                          ? "border-danger"
                          : ""
                          }`}
                        onClick={() => setScheduleModalShow(true)}
                        name="start_time"
                        value={localTime ? localTime : "Select Your Event Time"}
                        id="start_time"
                      />
                      <Form.Label className="form-label" htmlFor="start_time">
                        Event Time
                      </Form.Label>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <small className="text-end d-block text-dark">
                      required<span className="text-danger">*</span>
                    </small>
                    <div className="form-floating mb-3">
                      <Form.Control
                        type="button"
                        className={`timezone px-2 z-3 ${isValid && hasValue && !formData.start_time
                          ? "border-danger"
                          : ""
                          }`}
                        required
                        onClick={() => setScheduleModalShow(true)}
                        id="timezone"
                        value={
                          selectedTimeZone?.value || "Select Your Timezone"
                        }
                        placeholder="Select your time zone"
                      />
                    </div>
                  </Col>

                  <Col md={6} className="position-relative">
                    {formData?.hero_image_url || formData.hero_image_content ? (
                      <Button
                        className="deleteBtn p-1 btn-danger text-white bg-danger h-auto w-auto position-absolute top-0 end-0 mt-2 me-3 z-3"
                        onClick={() => {
                          setFormData({
                            ...formData,
                            hero_image_url: "",
                            hero_image_content: "",
                          });
                        }}
                      >
                        <Trash />
                      </Button>
                    ) : null}
                    <BannerUploaderEdit
                      key={formData?.hero_image_url}
                      label="Big Banner"
                      accept="image/png, image/jpg, image/jpeg"
                      imageType="hero_image"
                      placehold="https://placehold.co/1024x200"
                      state={formData}
                      setState={(data) => {
                        UploadFile(
                          formData.userId,
                          "hero_image",
                          data?.hero_image_content,
                          data?.hero_image_extension,
                          setReqLoading
                        ).then((url) => {
                          setFormData({
                            ...formData,
                            hero_image_url: url,
                            hero_image_content: "",
                          });
                        });
                      }}
                      imageURL={formData?.hero_image_url}
                      imageContent={formData?.hero_image_content}
                      imageExtension={formData?.hero_image_extension}
                    />
                  </Col>

                  <Col md={6} className="position-relative">
                    {formData?.listing_image_url ||
                      formData.listing_image_content ? (
                      <Button
                        className="deleteBtn p-1 btn-danger text-white bg-danger h-auto w-auto position-absolute top-0 end-0 mt-2 me-3 z-3"
                        onClick={() => {
                          setFormData({
                            ...formData,
                            listing_image_url: "",
                            listing_image_content: "",
                          });
                        }}
                      >
                        <Trash />
                      </Button>
                    ) : null}
                    <BannerUploaderEdit
                      key={formData?.listing_image_url}
                      label="Small Banner"
                      accept="image/png, image/jpg, image/jpeg"
                      imageType="listing_image"
                      placehold="https://placehold.co/280x180"
                      state={formData}
                      setState={(data) => {
                        UploadFile(
                          formData.userId,
                          "listing_image",
                          data?.listing_image_content,
                          data?.listing_image_extension,
                          setReqLoading
                        ).then((url) => {
                          setFormData({
                            ...formData,
                            listing_image_url: url,
                            listing_image_content: "",
                          });
                        });
                      }}
                      imageURL={formData?.listing_image_url}
                      imageContent={formData?.listing_image_content}
                      imageExtension={formData?.listing_image_extension}
                    />
                  </Col>

                  <Col md={12}>
                    <span className="d-block text-end text-dark">
                      required<span className="text-danger">*</span>
                    </span>
                    <Form.Group className="form-floating mb-3">
                      <Form.Control
                        as="textarea"
                        className={`${isValid && hasValue && !formData.description
                          ? "border-danger"
                          : ""
                          }`}
                        rows="4"
                        name="description"
                        value={formData?.description}
                        style={{ height: "auto" }}
                        required
                        id="description"
                        placeholder=" Enter your event description"
                        onChange={(e) => {
                          handleFieldChange("description", e.target.value);
                        }}
                      />
                      <Form.Label className="form-label" htmlFor="description">
                        What will you learn?
                      </Form.Label>
                    </Form.Group>
                    <small className="text-muted d-block mb-3">
                      <span className="text-danger">*</span>
                      {formData?.description?.length}/1900 characters
                    </small>
                  </Col>

                  <Col md={12}>
                    <Form.Group className="form-floating mb-3">
                      <Form.Control
                        id="video_url"
                        name="video_url"
                        value={formData?.video_url}
                        type="url"
                        placeholder="Video Url"
                        className="form-control input-md italicInput"
                        onChange={(e) =>
                          handleFieldChange("video_url", e.target.value)
                        }
                      />
                      <Form.Label className="form-label" htmlFor="video_url">
                        Event Video Link
                      </Form.Label>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <small className="text-end d-block text-dark">
                      required<span className="text-danger">*</span>
                    </small>
                    <Form.Group className="form-floating mb-3">
                      <Form.Select
                        id="category"
                        className={`${isValid && hasValue && !formData.category
                          ? "border-danger"
                          : ""
                          }`}
                        required
                        value={formData?.category}
                        name="category"
                        onChange={(e) =>
                          handleFieldChange("category", e.target.value)
                        }
                      >
                        <option value="">Category</option>
                        {Object.keys(categories)?.map((paramType) => (
                          <option
                            key={categories[paramType]?.key}
                            value={categories[paramType]?.value}
                          >
                            {categories[paramType]?.value}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <small className="text-end d-block text-dark">
                      required<span className="text-danger">*</span>
                    </small>
                    <Form.Group className="form-floating  mb-3">
                      <Form.Select
                        id="subcategorylevel1"
                        required
                        className={`${isValid && hasValue && !formData.subcategorylevel1
                          ? "border-danger"
                          : ""
                          }`}
                        value={formData?.subcategorylevel1}
                        name="subcategorylevel1"
                        onChange={(e) =>
                          handleFieldChange("subcategorylevel1", e.target.value)
                        }
                      >
                        <option value="">Select Payment Option</option>
                        {Object.keys(modes)?.map((paramType) => (
                          <option
                            key={modes[paramType]?.key}
                            value={modes[paramType]?.value}
                          >
                            {modes[paramType]?.value}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <small className="text-end d-block text-dark">
                      required<span className="text-danger">*</span>
                    </small>
                    <Form.Group className="form-floating mb-3">
                      <Form.Select
                        className={`${isValid && hasValue && !formData.subcategorylevel2
                          ? "border-danger"
                          : ""
                          }`}
                        aria-label="event type"
                        required
                        value={formData?.subcategorylevel2}
                        id="subcategorylevel2"
                        name="subcategorylevel2"
                        onChange={(e) =>
                          handleFieldChange("subcategorylevel2", e.target.value)
                        }
                      >
                        <option value="">Mode</option>
                        {Object.keys(entityTypesData)?.map((paramType) => (
                          <option
                            key={entityTypesData[paramType]?.key}
                            value={entityTypesData[paramType]?.value}
                          >
                            {entityTypesData[paramType]?.value}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  {formData?.subcategorylevel1?.toLocaleLowerCase() ===
                    "paid" && (
                      <Col md={12}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <div className="d-flex gap-3">
                          <Form.Group className="form-floating w-25 mb-3">
                            <Form.Select
                              id="currency"
                              required
                              className={`text-uppercase ${isValid && hasValue && !formData.currency
                                ? "border-danger"
                                : ""
                                }`}
                              name="currency"
                              value={formData?.currency}
                              onChange={(e) =>
                                handleFieldChange("currency", e.target.value)
                              }
                            >
                              <option value="">Currency</option>
                              <option value="usd">usd</option>
                              <option value="cad">cad</option>
                              <option value="inr">inr</option>
                              <option value="eur">eur</option>
                              <option value="gbp">gbp</option>
                            </Form.Select>
                          </Form.Group>
                          <Form.Group className="form-floating mb-3 flex-grow-1">
                            <Form.Control
                              id="amount"
                              name="amount"
                              type="number"
                              className={`text-italic ${isValid && hasValue && !formData.amount
                                ? "border-danger"
                                : ""
                                }`}
                              required
                              value={formData?.amount}
                              onChange={(e) =>
                                handleFieldChange("amount", e.target.value)
                              }
                              placeholder="Amount"
                            />
                            <Form.Label className="form-label" htmlFor="amount">
                              Enter Amount
                            </Form.Label>
                            <span className="position-absolute end-0 h-100 top-0 d-flex align-items-center pe-3">
                              .00
                            </span>
                          </Form.Group>
                        </div>
                      </Col>
                    )}

                  <Col md={12}>
                    <Form.Group className="form-floating mb-3">
                      <Form.Control
                        id="certificate"
                        name="certificate"
                        value={formData?.certificate}
                        type="text"
                        placeholder="Video Url"
                        className="form-control input-md italicInput"
                        onChange={(e) =>
                          handleFieldChange("certificate", e.target.value)
                        }
                      />
                      <Form.Label className="form-label" htmlFor="certificate">
                        Event Certificate Image Link
                      </Form.Label>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group className="form-floating mb-3">
                      <Form.Control
                        id="RSVP_question"
                        name="RSVP_question"
                        value={formData?.RSVP_question}
                        type="text"
                        placeholder="Video Url"
                        className="form-control input-md italicInput"
                        onChange={(e) =>
                          handleFieldChange("RSVP_question", e.target.value)
                        }
                      />
                      <Form.Label
                        className="form-label"
                        htmlFor="RSVP_question"
                      >
                        RSVP Question Link
                      </Form.Label>
                    </Form.Group>
                  </Col>

                  <Col md={12} className="mt-3">
                    <Button
                      type="button"
                      className="next demosEditBtn "
                      onClick={handleNext}
                    >
                      Next
                    </Button>
                  </Col>
                </Row>
              </fieldset>
            )}

            {step === 2 && (
              <fieldset className="wizard-fieldset show demosAddForm">
                <Row className="mx-0">
                  <div className="form-section-header mb-3">
                    <h4 className="theme-text-2">Organizer Details</h4>
                    <hr />
                  </div>
                  <Col md={6}>
                    <Form.Group className="form-floating mb-3">
                      <Form.Control
                        type="organizer_first_name"
                        placeholder="Organizer Name"
                        className="form-control italicInput"
                        name="organizer_first_name"
                        value={formData?.organizer_first_name}
                        id="organizer_first_name"
                        onChange={(e) =>
                          handleFieldChange(
                            "organizer_first_name",
                            e.target.value
                          )
                        }
                      />
                      <Form.Label
                        className="form-label"
                        htmlFor="organizer_first_name"
                      >
                        Organizer First Name
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="form-floating mb-3">
                      <Form.Control
                        type="organizer_last_name"
                        placeholder="Organizer Name"
                        className="form-control italicInput"
                        name="organizer_last_name"
                        value={formData?.organizer_last_name}
                        id="organizer_last_name"
                        onChange={(e) =>
                          handleFieldChange(
                            "organizer_last_name",
                            e.target.value
                          )
                        }
                      />
                      <Form.Label
                        className="form-label"
                        htmlFor="organizer_last_name"
                      >
                        Organizer Last Name
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className="form-floating mb-3">
                      <Form.Control
                        type="organizer_company_name"
                        placeholder="Organizer Company"
                        className="form-control italicInput"
                        name="organizer_company_name"
                        value={formData?.organizer_company_name}
                        id="organizer_company_name"
                        onChange={(e) =>
                          handleFieldChange(
                            "organizer_company_name",
                            e.target.value
                          )
                        }
                      />
                      <Form.Label
                        className="form-label"
                        htmlFor="organizer_company_name"
                      >
                        Organizer Company Name
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="form-floating mb-3">
                      <Form.Control
                        type="email"
                        placeholder="Organizer Email"
                        className="form-control italicInput"
                        name="organizer_email"
                        value={formData?.organizer_email}
                        id="organizer_email"
                        onChange={(e) =>
                          handleFieldChange("organizer_email", e.target.value)
                        }
                      />
                      <Form.Label
                        className="form-label"
                        htmlFor="organizer_email"
                      >
                        Organizer Email:
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="form-floating mb-3">
                      <Form.Control
                        type="number"
                        className="form-control"
                        name="whatsapp"
                        id="organizer_whatsapp"
                        placeholder="organizer_whatsapp"
                        value={formData?.organizer_whatsapp}
                        maxLength="15"
                        minLength="10"
                        onChange={(e) =>
                          handleFieldChange(
                            "organizer_whatsapp",
                            e.target.value
                          )
                        }
                      />
                      <Form.Label
                        className="form-label"
                        htmlFor="organizer_whatsapp"
                      >
                        Organizer Whatsapp
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="form-floating mb-3">
                      <Form.Control
                        type="number"
                        placeholder="Phone"
                        className="form-control"
                        name="organizer_phone"
                        value={formData?.organizer_phone}
                        id="organizer_phone"
                        maxLength="15"
                        minLength="10"
                        onChange={(e) =>
                          handleFieldChange("organizer_phone", e.target.value)
                        }
                      />
                      <Form.Label
                        className="form-label"
                        htmlFor="organizer_phone"
                      >
                        Organizer Phone
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="form-floating mb-3">
                      <Form.Control
                        type="url"
                        placeholder="Website"
                        value={formData?.organizer_website}
                        className="form-control"
                        name="organizer_website"
                        id="organizer_website"
                        onChange={(e) =>
                          handleFieldChange("organizer_website", e.target.value)
                        }
                      />
                      <Form.Label
                        className="form-label"
                        htmlFor="organizer_website"
                      >
                        Organizer Website
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className="form-floating mb-3">
                      <Form.Control
                        as="textarea"
                        style={{ height: "auto" }}
                        rows={4}
                        placeholder="bio"
                        value={formData?.organizer_bio}
                        className="form-control"
                        name="organizer_bio"
                        id="organizer_bio"
                        onChange={(e) =>
                          handleFieldChange("organizer_bio", e.target.value)
                        }
                      />
                      <Form.Label
                        className="form-label"
                        htmlFor="organizer_bio"
                      >
                        Organizer Brief BIO
                      </Form.Label>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mx-0">
                  <Col md={12} className="mt-3">
                    <Button
                      type="button"
                      className="previous-button demosEditBtn"
                      onClick={handlePrevious}
                    >
                      Previous
                    </Button>
                    <Button
                      type="button"
                      onClick={handleNext}
                      className="next demosEditBtn"
                    >
                      Next
                    </Button>
                  </Col>
                </Row>
              </fieldset>
            )}

            {step === 3 && (
              <fieldset className="wizard-fieldset show demosAddForm">
                <Row className="mx-0">
                  <Col md={12}>
                    <h5 className="theme-text-2">Speaker Details</h5>
                    <hr />
                  </Col>
                  <Col md={12}>
                    {speakers?.map((field, index) => (
                      <React.Fragment key={index}>
                        <SpeakerFieldset
                          key={index}
                          field={field}
                          onFieldChange={(newField) => {
                            const updatedFields = [...speakers];
                            updatedFields[index] = newField;
                            setSpeakers(updatedFields);
                          }}
                          indexField={index}
                          onRemove={() =>
                            removeItemById(speakers, setSpeakers, field.id)
                          }
                          inputIdPrefix={index}
                        />
                      </React.Fragment>
                    ))}
                    <Button
                      className="clickable add-button mb-3 ms-auto d-flex"
                      onClick={() => addField(setSpeakers, sponsors)}
                    >
                      Add Speaker
                    </Button>
                  </Col>
                  {/* --------------------- */}
                  <Col md={12} className="mt-3">
                    <Button
                      type="button"
                      className="previous-button demosEditBtn"
                      onClick={handlePrevious}
                    >
                      Previous
                    </Button>
                    <Button
                      type="button"
                      onClick={handleNext}
                      className="next demosEditBtn"
                    >
                      Next
                    </Button>
                  </Col>
                </Row>
              </fieldset>
            )}

            {step === 4 && (
              <fieldset className="wizard-fieldset show demosAddForm">
                <Row className="mx-0">
                  <Col md={12}>
                    <h5 className="theme-text-2">Session Topics</h5>
                    <hr />
                  </Col>
                  <Col md={12}>
                    {sessionTopics?.map((field, index) => (
                      <React.Fragment key={index}>
                        <SingleFieldset
                          fieldKey={"topic"}
                          type="textarea"
                          label={"Topic Description"}
                          key={index}
                          field={field}
                          onFieldChange={(newField) => {
                            const updatedFields = [...sessionTopics];
                            updatedFields[index] = newField;
                            setSessionTopics(updatedFields);
                          }}
                          indexField={index}
                          onRemove={() =>
                            removeItemById(
                              sessionTopics,
                              setSessionTopics,
                              field.id
                            )
                          }
                          inputIdPrefix={index}
                        />
                      </React.Fragment>
                    ))}
                    <Button
                      className="clickable add-button mb-3 ms-auto d-flex mt-3"
                      onClick={() => addField(setSessionTopics, sessionTopics)}
                    >
                      Add Topic
                    </Button>
                  </Col>
                  {/* --------------------- */}
                  {/* --------------------- */}
                  <Col md={12} className="mt-3">
                    <Button
                      type="button"
                      className="previous-button demosEditBtn"
                      onClick={handlePrevious}
                    >
                      Previous
                    </Button>
                    <Button
                      type="button"
                      onClick={handleNext}
                      className="next demosEditBtn"
                    >
                      Next
                    </Button>
                  </Col>
                </Row>
              </fieldset>
            )}

            {step === 5 && (
              <fieldset className="wizard-fieldset show demosAddForm">
                <Row className="mx-0">
                  <Col md={12}>
                    <h5 className="theme-text-2">Video Feedbacks</h5>
                    <hr />
                  </Col>
                  <Col md={12}>
                    {videoFeedbacks?.map((field, index) => (
                      <React.Fragment key={index}>
                        <SingleFieldset
                          fieldKey={"video_url"}
                          type="input"
                          label={"Video URL"}
                          key={index}
                          field={field}
                          onFieldChange={(newField) => {
                            const updatedFields = [...videoFeedbacks];
                            updatedFields[index] = newField;
                            setVideoFeedbacks(updatedFields);
                          }}
                          indexField={index}
                          onRemove={() =>
                            removeItemById(
                              videoFeedbacks,
                              setVideoFeedbacks,
                              field.id
                            )
                          }
                          inputIdPrefix={index}
                        />
                      </React.Fragment>
                    ))}
                    <Button
                      className="clickable add-button mb-3 ms-auto d-flex mt-3"
                      onClick={() =>
                        addField(setVideoFeedbacks, videoFeedbacks)
                      }
                    >
                      Add Video Feedback
                    </Button>
                  </Col>
                  <Col md={12}>
                    <h5 className="theme-text-2 mt-3">Text Feedbacks</h5>
                    <hr />
                  </Col>
                  <Col md={12}>
                    {textFeedbacks?.map((field, index) => (
                      <React.Fragment key={index}>
                        <FeedbackFieldset
                          key={index}
                          field={field}
                          onFieldChange={(newField) => {
                            const updatedFields = [...textFeedbacks];
                            updatedFields[index] = newField;
                            setTextFeedbacks(updatedFields);
                          }}
                          indexField={index}
                          onRemove={() =>
                            removeItemById(
                              textFeedbacks,
                              setTextFeedbacks,
                              field.id
                            )
                          }
                          inputIdPrefix={index}
                        />
                      </React.Fragment>
                    ))}
                    <Button
                      className="clickable add-button mb-3 ms-auto d-flex"
                      onClick={() => addField(setTextFeedbacks, textFeedbacks)}
                    >
                      Add Text Feedback
                    </Button>
                  </Col>
                  {/* --------------------- */}
                  {/* --------------------- */}
                  <Col md={12} className="mt-3">
                    <Button
                      type="button"
                      className="previous-button demosEditBtn"
                      onClick={handlePrevious}
                    >
                      Previous
                    </Button>
                    <Button
                      type="button"
                      onClick={handleNext}
                      className="next demosEditBtn"
                    >
                      Next
                    </Button>
                  </Col>
                </Row>
              </fieldset>
            )}

            {step === 6 && (
              <fieldset className="wizard-fieldset show demosAddForm">
                <Row className="mx-0">
                  <Col md={12}>
                    <h5 className="theme-text-2">Sponsors</h5>
                    <hr />
                  </Col>
                  <Col md={12}>
                    {sponsors?.map((field, index) => (
                      <React.Fragment key={index}>
                        <SponsorFieldset
                          key={index}
                          field={field}
                          onFieldChange={(newField) => {
                            const updatedFields = [...sponsors];
                            updatedFields[index] = newField;
                            setSponsors(updatedFields);
                          }}
                          indexField={index}
                          onRemove={() =>
                            removeItemById(sponsors, setSponsors, field.id)
                          }
                          inputIdPrefix={index}
                        />
                      </React.Fragment>
                    ))}
                    <Button
                      className="clickable add-button mb-3 ms-auto d-flex"
                      onClick={() => addField(setSponsors, sponsors)}
                    >
                      Add More Sponsors
                    </Button>
                  </Col>
                  <Col md={12} className="mt-3">
                    <Button
                      type="button"
                      className="previous-button demosEditBtn"
                      onClick={handlePrevious}
                    >
                      Previous
                    </Button>
                    <Button
                      type="button"
                      onClick={handleNext}
                      className="next demosEditBtn"
                    >
                      Next
                    </Button>
                  </Col>
                </Row>
              </fieldset>
            )}

            {step === 7 && (
              <fieldset className="wizard-fieldset show demosAddForm demosViewMoreSection">
                <Row className="mx-0">
                  <Col md={12}>
                    <h5 className="theme-text-2 mb-3">
                      Add any documents, brochures, fliers, images, videos and
                      links related to the {entityType} below
                    </h5>
                  </Col>
                  <Col md={12}>
                    <Tabs
                      defaultActiveKey="documents"
                      id="demo-details"
                      className="mx-0 mt-2"
                      fill
                    >
                      <Tab
                        eventKey="documents"
                        title="Docs"
                        className="m-0 mt-0"
                      >
                        <Card className="border-top-0 rounded-top-0 p-4">
                          <Card.Body>
                            {documentData?.map((field, index) => (
                              <React.Fragment key={index}>
                                <FileTriggerUploadFieldSet
                                  key={
                                    field?.file_name ||
                                    field?.file_content ||
                                    field?.file_extension
                                  }
                                  field={field}
                                  onFieldChange={(newField) => {
                                    const updatedFields = [...documentData];
                                    UploadFile(
                                      formData.userId,
                                      newField?.file_name || "document",
                                      newField?.file_content,
                                      newField?.file_extension,
                                      setReqLoading
                                    ).then((url) => {
                                      updatedFields[index] = {
                                        ...newField,
                                        url: url,
                                      };
                                      setDocumentData(updatedFields);
                                    });
                                  }}
                                  onRemove={() =>
                                    removeItemById(
                                      documentData,
                                      setDocumentData,
                                      field.id
                                    )
                                  }
                                  fileCategory="document"
                                  acceptedTypes="application/pdf,application/msword,text/plain"
                                  noteLabel="PDF/DOC/TXT"
                                  inputIdPrefix={`documentUpload-${index}`}
                                />
                              </React.Fragment>
                            ))}
                            <Button
                              className="clickable add-button mb-3 ms-auto d-flex"
                              onClick={() =>
                                addField(setDocumentData, documentData)
                              }
                            >
                              Add More Documents
                            </Button>
                          </Card.Body>
                        </Card>
                      </Tab>
                      <Tab
                        eventKey="Images"
                        title="Images"
                        className="m-0 mt-0"
                      >
                        <Card className="border-top-0 rounded-top-0 p-4">
                          <Card.Body>
                            {imageData?.map((field, index) => (
                              <React.Fragment key={index}>
                                <FileTriggerUploadFieldSet
                                  field={field}
                                  onFieldChange={(newField) => {
                                    const updatedFields = [...imageData];
                                    UploadFile(
                                      formData.userId,
                                      newField?.file_name || "image",
                                      newField?.file_content,
                                      newField?.file_extension,
                                      setReqLoading
                                    ).then((url) => {
                                      updatedFields[index] = {
                                        ...newField,
                                        url: url,
                                      };
                                      setImageData(updatedFields);
                                    });
                                  }}
                                  onRemove={() =>
                                    removeItemById(
                                      imageData,
                                      setImageData,
                                      field.id
                                    )
                                  }
                                  fileCategory="image"
                                  acceptedTypes="image/jpg,image/png,image/jpeg"
                                  noteLabel="PNG/JPG/JPEG "
                                  inputIdPrefix={`imageUpload-${index}`}
                                />
                              </React.Fragment>
                            ))}
                            <Button
                              className="clickable add-button mb-3 ms-auto d-flex"
                              onClick={() => addField(setImageData, imageData)}
                            >
                              Add More Images
                            </Button>
                          </Card.Body>
                        </Card>
                      </Tab>
                      <Tab
                        eventKey="Videos"
                        title="Videos"
                        className="m-0 mt-0"
                      >
                        <Card className="border-top-0 rounded-top-0 p-4">
                          <Card.Body className="d-flex flex-column gap-3">
                            {videoData?.map((field, index) => (
                              <VideoTriggerUploadFieldSet
                                key={index}
                                field={field}
                                onFieldChange={(newField) => {
                                  const updatedFields = [...videoData];
                                  if (newField.url) {
                                    updatedFields[index] = {
                                      ...newField,
                                      url: newField.url,
                                    };
                                    setVideoData(updatedFields);
                                  } else {
                                    UploadFile(
                                      formData.userId,
                                      newField?.file_name || "video",
                                      newField?.file_content,
                                      newField?.file_extension,
                                      setReqLoading
                                    ).then((url) => {
                                      updatedFields[index] = {
                                        ...newField,
                                        url: url,
                                      };
                                      setVideoData(updatedFields);
                                    });
                                  }
                                }}
                                indexField={index}
                                onRemove={() =>
                                  removeItemById(
                                    videoData,
                                    setVideoData,
                                    field.id
                                  )
                                }
                                fileCategory="video"
                                inputIdPrefix={`video-${index}`}
                              />
                            ))}
                            <Button
                              className="clickable add-button mb-3 ms-auto d-flex"
                              onClick={() => addField(setVideoData, videoData)}
                            >
                              Add More Videos
                            </Button>
                          </Card.Body>
                        </Card>
                      </Tab>
                    </Tabs>
                  </Col>
                  <Col md={12} className="position-relative mt-4">
                    <Button
                      type="button"
                      className="previous-button demosEditBtn"
                      onClick={handlePrevious}
                    >
                      Previous
                    </Button>
                    <Button
                      onClick={handleNext}
                      type="button"
                      className="next-button next demosEditBtn"
                    >
                      Next
                    </Button>
                  </Col>
                </Row>
              </fieldset>
            )}

            {step === 8 && (
              <fieldset className="wizard-fieldset show demosAddForm">
                <Row className="mx-0">
                  <Col md={12}>
                    <h5 className="theme-text-2">
                      Frequently Asked Questions (FAQs)
                    </h5>
                    <hr />
                  </Col>
                  <Col md={12}>
                    {FAQs?.map((field, index) => (
                      <React.Fragment key={index}>
                        <FAQsFieldset
                          isCourse={true}
                          key={index}
                          field={field}
                          onFieldChange={(newField) => {
                            const updatedFields = [...FAQs];
                            updatedFields[index] = newField;
                            setFAQs(updatedFields);
                          }}
                          indexField={index}
                          onRemove={() =>
                            removeItemById(FAQs, setFAQs, field.id)
                          }
                          inputIdPrefix={index}
                        />
                      </React.Fragment>
                    ))}
                    <Button
                      className="clickable add-button mb-3 ms-auto d-flex"
                      onClick={() => addField(setFAQs, FAQs)}
                    >
                      Add More FAQs
                    </Button>
                  </Col>

                  <Col md={12} className="mt-3">
                    <Button
                      type="button"
                      className="previous-button demosEditBtn"
                      onClick={handlePrevious}
                    >
                      Previous
                    </Button>
                    <Button type="submit" className="next demosEditBtn">
                      Submit
                    </Button>

                    <Toast
                      show={showErrorToast}
                      onClose={() => setShowErrorToast(false)}
                      autohide
                      delay={3200}
                      className="bg-white opacity-1 position-absolute"
                      style={{
                        bottom: "calc(100% + 10px)",
                        right: "10px",
                        zIndex: "999",
                      }}
                    >
                      <Toast.Header closeButton={false}>
                        <strong className="mr-auto text-danger">
                          <XCircleFill />
                          &nbsp;Error
                        </strong>
                      </Toast.Header>
                      <Toast.Body className="text-dark">
                        Fill all the (
                        <span className="text-danger">required*</span>) fields
                        to submit
                      </Toast.Body>
                    </Toast>
                  </Col>
                </Row>
              </fieldset>
            )}
          </Form>
        </Row>
      )}

      <ScheduleDateModalCourse
        show={scheduleModalShow}
        setshow={setScheduleModalShow}
        entity="cohort"
        entityType={entities}
        state={formData}
        setstate={setFormData}
        onHide={() => {
          setScheduleModalShow(false);
        }}
      />
    </Container>
  );
}

export default withRouter(AddEditPropertyEvent);
